import { LOGOUT_ACTION, SET_CURRENT_USER } from "../actions/types";

const initialState = {
  userInfo: {},
  permission: [],
  menu: [],
  settings: {}
};

const currentUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENT_USER:
      return action.currentUser;
    case LOGOUT_ACTION:
      return initialState;
    default:
      return state;
  }
};

export default currentUserReducer;
